import mixins from 'vue-typed-mixins';

import { DetectedDevice } from '@/interfaces/DetectedDevice';

export const deviceDetector = mixins().extend({
	computed: {
		detectedDevice(): DetectedDevice {
			return {
				isAndroid: /android/i.test(navigator.userAgent),
				isIOS: (/iPad|iPhone|iPod/.test(navigator.platform) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)) && !window.MSStream,
				isHuawei: /huawei/i.test(navigator.userAgent)
			};
		}
	}
});
